// @ts-ignore
/* eslint-disable */
import request from "src/lib/axios";

/** 获取当前用户可见菜单树 GET /api/v1/me/menus */
export async function MeMenuControllerGetMyMenusV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.MeMenuControllerGetMyMenusV1Params,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputMenuDtoArray>("/api/v1/me/menus", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}
